import { render, staticRenderFns } from "./DbAccounts.vue?vue&type=template&id=0979d410&scoped=true&"
import script from "./DbAccounts.vue?vue&type=script&lang=js&"
export * from "./DbAccounts.vue?vue&type=script&lang=js&"
import style0 from "./DbAccounts.vue?vue&type=style&index=0&id=0979d410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979d410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0979d410')) {
      api.createRecord('0979d410', component.options)
    } else {
      api.reload('0979d410', component.options)
    }
    module.hot.accept("./DbAccounts.vue?vue&type=template&id=0979d410&scoped=true&", function () {
      api.rerender('0979d410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/DbAccounts.vue"
export default component.exports